import { Alert } from 'react-bootstrap';
import PropTypes from 'prop-types';
import React from 'react';

export default function LeadAlert({ errorMessage, showAlert }) {
  if (!showAlert) return null;

  const message = errorMessage ? errorMessage : 'Lead has already been added to this project';

  return (
    <Alert bsStyle="danger" name="errors-alert">{message}</Alert>
  );
}

LeadAlert.propTypes = {
  errorMessage: PropTypes.string,
  showAlert: PropTypes.bool
};
